import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BanksComponent } from '../admin/banks/banks.component';
import { AppointmentStatusesComponent } from '../admin/appointment-statuses/appointment-statuses.component';
import { ClientStatusesComponent } from '../admin/client-statuses/client-statuses.component';
import { IncomesComponent } from '../admin/incomes/incomes.component';
import { PaymentTypesComponent } from '../admin/payment-types/payment-types.component';
import { ProductTypesComponent } from '../admin/product-types/product-types.component';
import { WorkStatusesComponent } from '../admin/work-statuses/work-statuses.component';
import { PolicyStatusesComponent } from '../admin/policy-statuses/policy-statuses.component';
import { BranchOfficesComponent } from '../admin/branch-offices/branch-offices.component';
import { ProductRolesComponent } from '../admin/product-roles/product-roles.component';
import { RolesComponent } from '../admin/roles/roles.component';
import { UsersComponent } from '../admin/users/users.component';
import { OccupationsComponent } from '../admin/occupations/occupations.component';


const routes: Routes = [
  {
    path: 'users',
    component: UsersComponent
  },
  {
    path: 'occupations',
    component: OccupationsComponent
  },
  {
    path: 'banks',
    component: BanksComponent
  },
  {
    path: 'appointment-statuses',
    component: AppointmentStatusesComponent
  },
  {
    path: 'client-statuses',
    component: ClientStatusesComponent
  },
  {
    path: 'incomes',
    component: IncomesComponent
  },
  {
    path: 'payment-types',
    component: PaymentTypesComponent
  },
  {
    path: 'product-types',
    component: ProductTypesComponent
  },
  {
    path: 'policy-statuses',
    component: PolicyStatusesComponent
  },
  {
    path: 'work-statuses',
    component: WorkStatusesComponent
  },
  {
    path: 'branch-offices',
    component: BranchOfficesComponent
  },
  {
    path: 'product-role',
    component: ProductRolesComponent
  },
  {
    path: 'role',
    component: RolesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminPanelRoutingModule { }
